export { Modal } from './Modal'
export { MODAL_TYPE, type ModalAPI, type ModalProps } from './types'
